import React, { FC } from 'react'

import { getNewUuid, SwitchButton, useIsTabletOrMobile } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import { SwitchBasedFilter } from '@new/__global/components/Filters/FiltersVariations/Switch'

import * as S from '../Filters.styles'

interface SwitchBasedFilterProps extends FiltersSharedProps {
  title: string
  initialValue?: boolean
  onChange: (value?: boolean) => void
  disabled?: boolean
}

export const InlineSwitch: FC<SwitchBasedFilterProps> = ({
  disabled,
  title,
  initialValue,
  isSidebarFilter,
  isAccordionOpen,
  onChange,
}) => {
  const isTabletOrMobile = useIsTabletOrMobile()
  const uuid = getNewUuid()

  return isTabletOrMobile || isSidebarFilter ? (
    <SwitchBasedFilter
      title={title}
      initialValue={initialValue}
      isSidebarFilter={isSidebarFilter}
      isAccordionOpen={isAccordionOpen}
      onChange={onChange}
    />
  ) : (
    <S.FilterFrame>
      <SwitchButton
        disabled={disabled}
        checked={!!initialValue}
        onChange={() => onChange(!initialValue)}
        id={`switch-filter-${title}-${uuid}`}
        titleLeft={title}
      />
    </S.FilterFrame>
  )
}
